import { http } from '@/core/api/';
import EduEspCode from '@/utils/constants/eduEspCode';

const schoolBaseURL = 'api/schools';

export default {
  getSchoolTypes() {
    return http.get(
      `api/code/getEduEspCodes?codeType=${EduEspCode.LocationTypes}`
    );
  },
  getSchools() {
    return http.get(`${schoolBaseURL}/getLocationSchools`);
  },
  getSchoolsByType(schoolType) {
    return http.get(
      `${schoolBaseURL}/getLocationSchoolsByType?schoolType=${schoolType}`
    );
  },
  getMunicipalities() {
    return http.get(`${schoolBaseURL}/municipalities`);
  },
  getSchoolResults(filter) {
    return http.get(`${schoolBaseURL}/getSchoolsResults`, {
      params: {
        locationSchoolId: filter.locationSchoolId,
        schoolType: filter.schoolType?.id || '',
        isActive: filter.isActive,
        pageIndex: filter.currentPage,
        pageSize: filter.count,
      },
    });
  },
  getSchoolById(id) {
    return http.get(
      `${schoolBaseURL}/getlocationschool?locationSchoolId=${id}`
    );
  },
  saveSchool(data) {
    return http.post(`${schoolBaseURL}/create`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  updateSchool(data) {
    return http.put(`${schoolBaseURL}/update`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getSchoolEducationalEnvironmentTypes() {
    return http.get(`${schoolBaseURL}/schooleducationalenvironmenttypes`);
  },
  getRLVClassificationTypes() {
    return http.get(`${schoolBaseURL}/rlvclassificationTypes`);
  },
  getSchoolLevelTypes() {
    return http.get(`${schoolBaseURL}/schoolleveltypes`);
  },
};
